<template>
  <div class="alphabet-content">
    <h4 class="about-title">{{ ls_alphabet }}</h4>
    <div class="alphabet-card">
      <div class="alphabet-banner">
        <b-link :href="host + '/ads/show/18.html'" target="_blank" class="banner-link">
          <img class="banner-img" :src="host + '/ads/show/18.png'" alt="Ads">
        </b-link>
      </div>
      <div class="alphabet-table">
        <table class="table-content table">
          <thead>
            <tr>
              <th class="latyn-th" scope="col" colspan="4">{{ ls_LatynAlphabet }}</th>
              <th class="table-devider"></th>
              <th class="cyrl-th" scope="col" colspan="2">{{ ls_CyrlAlphabet }}</th>
            </tr>
            <tr class="tr-title">
              <th scope="col">№</th>
              <th scope="col">{{ ls_LatynDisplay }}</th>
              <!-- <th scope="col">{{ ls_HandWrite }}</th> -->
              <th scope="col">{{ ls_LatynPronounce }}</th>
              <th scope="col">{{ ls_SpeakSound }}</th>
              <th class="table-devider"></th>
              <th scope="col">{{ ls_CyrlDisplay }}</th>
              <th scope="col">{{ ls_CyrlPronounce }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(alphabet, index) in alphabetList"
              :key="index"
              @mouseenter="$parent.hovered(alphabet)"
              class="alphabet-description">
              <th class="alphabet-index" scope="row">{{ index + 1 }}</th>
              <td class="alphabet-latyndisplay" :style="{ color: alphabet.fontColor !== '' ? alphabet.fontColor : '' }">{{ alphabet.latynDisplay }}</td>
              <!-- <td class="alphabet-handwrite" :style="{ color: alphabet.fontColor !== '' ? alphabet.fontColor : '' }">{{ alphabet.latynDisplay }}</td> -->
              <td class="alphabet-latynpronounce">{{ alphabet.latynPronounce }}</td>
              <td class="alphabet-sound">
                <i @click.prevent="$parent.playAudio(alphabet.speakSoundUrl)" class="sound fas fa-volume-up"></i>
              </td>
              <td class="table-devider"></td>
              <td class="alphabet-cyrldisplay">{{ alphabet.cyrlDisplay }}</td>
              <td class="alphabet-cyrlpronounce">{{ alphabet.cyrlPronounce }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["alphabetList"],
  computed: {
    host() {
      return this.$store.state.host;
    },
    ls_CyrlDisplay() {
      return this.$store.state.languagePack.ls_CyrlDisplay;
    },

    ls_CyrlPronounce() {
      return this.$store.state.languagePack.ls_CyrlPronounce;
    },

    ls_LatynDisplay() {
      return this.$store.state.languagePack.ls_LatynDisplay;
    },

    ls_LatynPronounce() {
      return this.$store.state.languagePack.ls_LatynPronounce;
    },

    ls_SpeakSound() {
      return this.$store.state.languagePack.ls_SpeakSound;
    },

    ls_HandWrite() {
      return this.$store.state.languagePack.ls_HandWrite;
    },

    ls_alphabet() {
      return this.$store.state.languagePack.ls_alphabet;
    },

    ls_LatynAlphabet() {
      return this.$store.state.languagePack.ls_LatynAlphabet;
    },

    ls_CyrlAlphabet() {
      return this.$store.state.languagePack.ls_CyrlAlphabet;
    }
  }
};
</script>

<style lang="scss" scoped>
.alphabet-content {

  .alphabet-card {
    padding: 1rem;
    background-color: #ffffff;
    border: 1px solid #ededed;
  }

  .alphabet-title {
    color: #008496;
    margin-bottom: 1rem;
  }

  .alphabet-banner {

    .banner-link {
      .banner-img {
        width: 100%;
      }
    }
  }

  .alphabet-tabel {
    margin-top: 1rem;
  }
}
</style>
